module.exports = __webpack_public_path__ + "images/37f879f1b63754ce72e8a8f1b6e21bed.svg";